import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { getIntroductionRoutes } from './introduction-routes';
import { getDemographicRoutes } from './demographic-routes';
import { getAssessmentRoutes, TaskRoutes, OutcomeRoutes } from './assessment-routes';
import { TerminationRoutes } from './termination-routes';
import SessionRequiredRoute from './session-required-route';
import { connect } from 'react-redux';

const Routes = (
    <Switch>
        {sessionStorage.getItem('temp-version-id') ? ((getIntroductionRoutes(sessionStorage.getItem('temp-version-id')))) ? (getIntroductionRoutes(sessionStorage.getItem('temp-version-id'))).map((route, index) => {
            if (route.requireSessionID) {
                return (<SessionRequiredRoute key={`introduction_${index}`} path={route.path} exact component={route.component} />)
            } else {
                return (<Route key={`introduction_${index}`} path={route.path} exact component={route.component} />)
            }
        }): null: null}
        {sessionStorage.getItem('temp-version-id') ? ((getDemographicRoutes(sessionStorage.getItem('temp-version-id')))) ? (getDemographicRoutes(sessionStorage.getItem('temp-version-id'))).map((route, index) => (
            <SessionRequiredRoute key={`demographic_${index}`} path={route.path} exact component={route.component} />
        )): null: null}

        {sessionStorage.getItem('temp-version-id') ? ((getAssessmentRoutes(sessionStorage.getItem('temp-version-id')))) ? (getAssessmentRoutes(sessionStorage.getItem('temp-version-id'))).map((route, index) => (
            <SessionRequiredRoute key={`assessment_${index}`} path={route.path} exact component={route.component} />
            // <SessionRequiredRoute key={`assessment_${index}`} path={route.path} exact component={route.component} />
        )): null: null}

        {TaskRoutes.map((route, index) => (
            <SessionRequiredRoute key={`assessment_${index}`} path={route.path} exact component={route.component} />
        ))}

        {OutcomeRoutes.map((route, index) => (
            <SessionRequiredRoute key={`assessment_${index}`} path={route.path} exact component={route.component} />
        ))}


        {TerminationRoutes.map((route, index) => (
            <SessionRequiredRoute key={`termination_${index}`} path={route.path} exact component={route.component} />
        ))}
    </Switch>
)

export default Routes;